'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import withNewFileWizard from 'DesignFinderUI/components/modals/hoc/withNewFileWizard';
import withNewThemeWizard from 'DesignFinderUI/components/modals/hoc/withNewThemeWizard';
import withNewFunctionWizard from 'DesignFinderUI/components/modals/hoc/withNewFunctionWizard';
import withNewProjectWizard from 'DesignFinderUI/components/modals/hoc/withNewProjectWizard';
import withDeployFunctionWizard from 'DesignFinderUI/components/modals/hoc/withDeployFunctionWizard';
import withDeployProjectWizard from 'DesignFinderUI/components/modals/hoc/withDeployProjectWizard';
import withAssetActions from 'DesignFinderUI/hocs/withAssetActions';
import withActionsModals from 'DesignFinderUI/components/modals/hoc/withActionsModals';
import NewActionsDropdown from 'DesignFinderUI/components/actions/NewActionsDropdown';
import { compose } from 'redux';

class PrimaryActionsDropdown extends Component {
  render() {
    const {
      assetActions
    } = this.props;
    const actions = [assetActions.primaryActions, assetActions.deleteAction];
    return /*#__PURE__*/_jsx(NewActionsDropdown, Object.assign({}, this.props, {
      actions: actions
    }));
  }

}

PrimaryActionsDropdown.propTypes = {
  assetActions: PropTypes.object.isRequired
};
PrimaryActionsDropdown.defaultProps = {
  assetActions: {}
};
export default compose(withNewFileWizard, withNewThemeWizard, withNewFunctionWizard, withNewProjectWizard, withDeployFunctionWizard, withDeployProjectWizard, withActionsModals, withAssetActions)(PrimaryActionsDropdown);